export default context => {
    const moduleId = context.getters.moduleId;

    const startDate = context.rootState[`${moduleId}_additional-questions_date-start-complaint`];
    const endDate = context.rootState[`${moduleId}_additional-questions_date-end-complaint`];

    let validity = {
        ...startDate.validity,
    };
    if (startDate.value.length && endDate.value.length) {
        const durationStart = new Date(startDate.value);
        const durationEnd = new Date(endDate.value);
        validity = {
            ...validity,
            invalidDuration: durationStart > durationEnd,
        };
    } else {
        validity = {
            ...validity,
            invalidDuration: false,
        };
    }

    return validity;
};